export { default } from "./SendToDoctor.gql";
